// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	//burger menu 
	const burgerMenuBtn = document.querySelector('[data-burgeropen]');
	const burgerMenuClose = document.querySelector('[data-burgerclose]');
	const burgerMenu = document.querySelector('[data-burgermenu]');

	if(burgerMenu) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});
		burgerMenuClose.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//cms form focus animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}